<template>
  <div class="modal-overlay show">
    <transition name="modal">
      <div ref="modal" class="modal-popup modal-popup--welcome">
        <div @click="close" class="close-modal close-modal--welcome">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke="#64636f"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        <div class="popup-body popup-body--welcome">
          <div class="body-left">
            <h2 class="font-bold text-4xl dark:text-primary-white">
              {{ getWelcomeContent.title }}
            </h2>
            <p class="description dark:text-greyscale-500">
              {{ getWelcomeContent.text }}
            </p>
            <Button @click="startTour()" class="primary large w-[200px]">
              Let's start
            </Button>
          </div>
          <div class="image-wrapper">
            <img :src="getWelcomeContent.url" alt="welcome image" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
export default {
  name: "Applications",
  components: { Button },
  computed: {
    ...mapGetters(["getWelcomeContent"]),
  },
  methods: {
    ...mapActions(["emitIsWelcomeShowed"]),
    startTour() {
      this.emitIsWelcomeShowed(true);
      this.$emit("start-tour");
    },
    close() {
      this.emitIsWelcomeShowed(true);
      this.$emit("close");
    },
  },
};
</script>

<style>
@import "index.module.css";
</style>
